import Logger from 'nightingale';
import { device } from '../params';
import { runSyncAsUser } from '../utils/exec';

const logger = new Logger('app:commands:sound');

const set = (output: 'hdmi' | 'jack'): void => {
  logger.info('change sound output', { output });
  runSyncAsUser('./sound.sh', [device.sound.type, ...device.sound[output]]);
};

let currentSoundOutput;

export const update = (config: Object) => {
  if (!config.sound || !device.sound || !device.sound[config.sound]) {
    currentSoundOutput = null;
    return;
  }

  if (currentSoundOutput === config.sound) return;
  currentSoundOutput = config.sound;

  set(currentSoundOutput);
};
